// extracted by mini-css-extract-plugin
export default {"spin":"ScrollDialog_spin__jlsD6","coin-spin":"ScrollDialog_coin-spin__KkaME"};